import type { LayoutProps } from "@/features/companyDetail/types"
import type { PagesRouterPage } from "@/types"
import type { PropsWithChildren } from "react"

import { ArticleDetails } from "@/features/companyDetail/components/ArticleDetails/ArticleDetails/ArticleDetails"
import { Layout } from "@/features/companyDetail/components/Layout/Layout"

export const PageContent: PagesRouterPage<PropsWithChildren<LayoutProps>> = props => {
  return (
    <Layout {...props}>
      <ArticleDetails />
    </Layout>
  )
}
